import { badge } from 'fontawesome';
import React, { createContext,useReducer } from 'react'
import { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { UserContext } from '../Component/User/UserContext';
import { client } from '../utils';
export const ProductsContext = createContext();
export const ProductsContextProvider=(props)=> {
    const {Userinfo}=useContext(UserContext);
    const [productinfo,setproductinfo]=useState({products:[],AllProducts:[],loading:false })
    const [productloading,setproductloading]=useState();
    const [filter,setfilter]=useState(false);
    const [catdata,setCatdata]=useState([]);
    const [catloading,setcatloading]=useState(false);
    const [subcategories,setsubcategories]=useState([]);
    const [subcatloading,setsubcatloading]=useState(false);
    const [wishlist,setwishlist]=useState([]);
    const [loadingwishlist,setloadingwishlist]=useState(false);
    const [notified,setnotified]=useState(false);
    const [Slabs,setSlabs]=useState([]);
    const [slabsloading,setslabsloading]=useState(false);
    const [filters,setfilters]=useState({
      searchkey:'',
      pricefrom:0,
      priceto:0,
      categories:[],
      subcategories:[],
      stockfilter:true,
      discfrom:0,
      discto:0,
      slabs:[],
    })
    const setselsubcat=(x,cat)=>{
      setfilters({...filters,subcategories:[...filters.subcategories.filter((y)=>(y.category != cat)),...x]})
      Filterwithsubcategories([...filters.subcategories.filter((y)=>(y.category != cat)),...x]);
    }
    useEffect(()=> {
          Fetchcategories();
          Fetchsubcategories();
          FetchProducts();
          Fetchwishlist(undefined,undefined);
          FetchSlabs();
          },[Userinfo.uuid])
   const FetchProducts= async(searchtext,stockfilter=true)=>{
    if (Userinfo.uuid!="")
         {     
          setproductloading(true);
          //
           let header={}
           if (searchtext !='' && searchtext!=undefined && searchtext!=null)
                 header.search=searchtext;
           if (stockfilter !='' && stockfilter!=undefined && stockfilter!=null && stockfilter!=false)
                 header.stockfilter=stockfilter;
          //
          client('/api/fetchprodcuts',{headers:header})
              .then((data)=>{
            productinfo.AllProducts=data.data;
            if (searchtext===undefined || searchtext===''){setIndex(52);setIsCompleted(false)}
            filters.searchkey=(searchtext===undefined) ? '' : searchtext;
            productinfo.products= productinfo.AllProducts.filter((obj) => 
                   ((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
                  &&((obj.minprice >= filters.pricefrom && obj.maxprice<=filters.priceto && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN'))
                  && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0))
                  && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
                  && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
                  && ((filters.slabs.some(sb=>(obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
                );
                setproductinfo(productinfo);
                setproductloading(false);
           }).catch((ex)=>{
              console.log(ex)
              setproductinfo({products: [],AllProducts:[] })
              setproductloading(false);
              })
          }
   } 
   const Fetchcategories= ()=>{
    setcatloading(true);
    client('/api/categories',{})
       .then((data)=>{
             setCatdata(data.data);
             setcatloading(false);
        }
          ).catch((ex)=>{
            //toast.error(ex.message)
            setcatloading(false);
          })
  }
  const FetchSlabs= ()=>{
    setslabsloading(true);
    client('/api/slab-masters?sort[0]=slabID:asc',{})
       .then((data)=>{
             let slbs=[]
                data.data.map((x)=>{
                  slbs.push({ value: x.attributes.slabID , label : x.attributes.desc,
                    showinfilter:x.attributes.showinfilter,additionalfilterslabs:x.attributes.additionalfilterslabs})
               })
             setSlabs(slbs)
             setslabsloading(false);
        }
          ).catch((ex)=>{
            setslabsloading(false);
          })
  }
const Fetchsubcategories= ()=>{
        setsubcatloading(true);
        client('/api/subcategories?populate=*',{})
           .then((data)=>{
                let subcat=[]
                data.data.map((x)=>{
                subcat.push({ value: x.attributes.code , label : x.attributes.description,category: x.attributes.category.data.attributes.DESC })
               })
               setsubcategories(subcat);
               setsubcatloading(false);
            }
              ).catch((ex)=>{
                //toast.error(ex.message)
                console.log(ex);
                setsubcatloading(false);
              })
           }


           const Fetchwishlist=(action,matnr,inforequired="true")=>{
            setloadingwishlist(true);
            client('/api/wishlist/fetchwishlist',{headers:{uuid:Userinfo.uuid,inforequired:inforequired}})
               .then((data)=>{
                  if (action!=undefined) //default load 
                     {
                     let items=[] ; 
                     let items_matnr=[] ; 
                     //check material existing or not , if existing remove from the list
                      if ((data[0]?.items.filter(x=> x.matnr===matnr).length===0) || 
                         (data[0]?.items.filter(x=> x.matnr===matnr).length ===undefined) ) 
                      {
                      if (data[0]?.id > 0) //check first time adding wishlist
                         {
                         data[0]?.items.push({matnr:matnr}) ;
                         //items= data[0]?.items; 
                         items= Object.assign([],data[0].items); 
                         }
                      else {
                        items.push({matnr:matnr})} 
                      }
                     else { //remove from the list
                          data[0].items.splice(data[0].items.findIndex(y=>(y.matnr===matnr)),1)
                          items=Object.assign([],data[0].items);
                        }
                      //updating to database
                      items.map(ematrn=>{ items_matnr.push({matnr:ematrn.matnr})  })
                      if  (data[0]?.id > 0){ // no need to wait for response from the below transaction.
                      setwishlist(data);//to increase the userexperience..
                      setloadingwishlist(false);
                      }
                      client('/api/wishlists/' + (data[0]?.id > 0 ? data[0]?.id : '') ,
                        { method:(data[0]?.id > 0) ? 'PUT':'POST', 
                          body:{ data: { uuid:Userinfo.uuid,items:items_matnr}} })
                         .then((datan)=>{
                               if  (data[0]?.id === 0 || data[0]?.id ===undefined){ //will wait for getting the wishlist primary key.
                                setwishlist([{"id": datan.data.id,"uuid": datan.data.uuid,"items": datan.data.attributes.items}]);
                                setloadingwishlist(false);
                                }
                          }
                          ).catch((ex)=>{
                               setwishlist([]);
                          })
                    }
                    else {
                          setwishlist(data);
                          setloadingwishlist(false);
                        }

                  }
                  ).catch((ex)=>{
                    setwishlist([]);
                    setloadingwishlist(false);
                  })

     } 
  const addwishlist=(content)=>{
    let bodycont=(wishlist[0].id) ? {data: { uuid: Userinfo.uuid , items:content[0].attributes.items} } : 
                                    {data: { uuid: Userinfo.uuid , items:content} }
    client((wishlist[0].id) ? '/api/wishlists/' + wishlist[0].id  : '/api/wishlists' ,
    {method:(wishlist[0].id > 0) ? 'PUT':'POST',body:bodycont})
       .then((data)=>{
           setwishlist([data.data]);
        }
          ).catch((ex)=>{
            setwishlist([]);
          })

  }        
   const FilterProducts=(selcatgories)=>{
           setfilter((filter===true)? false:true)
           productinfo.products= productinfo.AllProducts.filter((obj) => 
                   (((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
                  &&( (obj.minprice >= filters.pricefrom && obj.maxprice<=filters.priceto && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN' ))
                  && ((selcatgories.some(y=> y.id===obj.category)) || (selcatgories.length===0)))
                  && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
                  && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
                  && ((filters.slabs.some(sb=> (obj.slabids.includes(sb.value))  || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
                  );
            setproductinfo(productinfo);
    }
    const FilterProducts_slabs=(slabs)=>{
      //setfilter((filter===true)? false:true)
      setfilters({...filters,['slabs']:slabs});
      productinfo.products= productinfo.AllProducts.filter((obj) => 
              (((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
             &&( (obj.minprice >= filters.pricefrom && obj.maxprice<=filters.priceto && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN' ))
             && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0)))
             && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
             && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
             && ((slabs.some(sb=> (obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (slabs.length===0) )
             );
       setproductinfo(productinfo);
}
   const searchproductswithprice=(pricefrom ,priceto)=>{
   setfilter((filter===true)? false:true)
   setIndex(52);setIsCompleted(false)
   productinfo.products= productinfo.AllProducts.filter((obj) => 
          ((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
           &&( ( parseFloat(obj.minprice) >=parseFloat(pricefrom) &&  parseFloat( obj.minprice) <= parseFloat(priceto) && priceto!=0 ) || (priceto===0 || priceto.toString()==='NaN'))
           && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0))
           && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
           && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
           && ((filters.slabs.some(sb=>(obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
           );
        setproductinfo(productinfo);
    }
    const searchproductswithname=(name)=>{
      setfilter((filter===true)? false:true)
      productinfo.products= productinfo.AllProducts.filter((obj) => 
           ((obj.desc.toUpperCase().includes(name.toUpperCase())===true || (obj.matnr.toUpperCase().includes(name.toUpperCase())) ) || name==='')
           &&( (parseFloat(obj.minprice)>=parseFloat(filters.pricefrom) &&  parseFloat(obj.minprice) <= parseFloat(filters.priceto) && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN' ))
           && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0))
           && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
           && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
           && ((filters.slabs.some(sb=>(obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
           );
      setproductinfo(productinfo);
  }
  const Filterwithsubcategories=(subcat)=>{
    setfilter((filter===true)? false:true)
    productinfo.products= productinfo.AllProducts.filter((obj) => 
         ((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
         &&( (parseFloat(obj.minprice)>=parseFloat(filters.pricefrom) &&  parseFloat(obj.minprice) 
         <= parseFloat(filters.priceto) && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN'))
         && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0))
         && ((subcat.some(s=>( obj.materialgroup===s.value))) || (subcat.length===0) )
         && ((filters.discfrom!=0 || filters.discto!=0)? obj.maxdiscountperc >=filters.discfrom && obj.maxdiscountperc<=filters.discto :true)
         && ((filters.slabs.some(sb=>(obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
         );
    setproductinfo(productinfo);
}
const FilterAllProducts_discount=(minValue,maxValue)=>{
  productinfo.products= productinfo.AllProducts.filter((obj) => 
       ((obj.desc.toUpperCase().includes(filters.searchkey.toUpperCase())===true) || filters.searchkey==='')
       &&( (parseFloat(obj.minprice)>=parseFloat(filters.pricefrom) &&  parseFloat(obj.minprice) 
       <= parseFloat(filters.priceto) && filters.priceto!=0) || (filters.priceto===0 || filters.priceto.toString()==='NaN'))
       && ((filters.categories.some(y=> y.id===obj.category)) || (filters.categories.length===0))
       && ((filters.subcategories.some(s=>( obj.materialgroup===s.value))) || (filters.subcategories.length===0) )
       && ((minValue!=0 || maxValue!=0)? obj.maxdiscountperc >=minValue && obj.maxdiscountperc<=maxValue :true)
       && ((filters.slabs.some(sb=>(obj.slabids.includes(sb.value)) || (sb.additionalfilterslabs?.some(af=> obj.slabids.includes(af.value))) )) || (filters.slabs.length===0) )
       );
  setproductinfo(productinfo);
}
    const [isCompleted, setIsCompleted] = useState(false)
    const [index, setIndex] = useState(52)
    const initialproducts = productinfo.products.slice(0, index)
    const loadMore = () => {
      setIndex(index + 52)
      if (index >= productinfo.products.length) {
        setIsCompleted(true)
      } else {
        setIsCompleted(false)
      }
    }
   return  (
            <ProductsContext.Provider value={{ products: productinfo.products,loading:productloading,
                                     FilterProducts:FilterProducts,
                                     AllProducts:productinfo.AllProducts,FetchProducts,loadMore,
                                     initialproducts,isCompleted,searchproductswithprice,searchproductswithname,
                                     filters,setfilters,catdata,catloading,subcategories,
                                     subcatloading,setselsubcat,wishlist,Fetchwishlist,
                                     loadingwishlist,setnotified,notified,FilterAllProducts_discount,Slabs,slabsloading,FilterProducts_slabs}} >
                {props.children}
            </ProductsContext.Provider>
        )
}

